import script from "./CreditsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsBar.vue?vue&type=script&setup=true&lang=js"

import "./CreditsBar.vue?vue&type=style&index=0&id=797fc29e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797fc29e"]])

export default __exports__